<template>
    <div>
        <b-button class="w-100 mb-1"
                  variant="outline-secondary"
                  v-show="!servicestatus.problemHasBeenAcknowledged"
                 @click="visible = !visible">
            <i class="fa-solid fa-user"></i>
            {{ $t('action-items.acknowledge')}}
        </b-button>
        <b-collapse v-model="visible" class="mt-2 mb-2 w-100">
            <b-list-group-item>
                <b-form>
                    <b-form-group
                        id="input-group-ack-text"
                        :label="$t('forms.message')"
                        label-for="textarea-acknowlegde">
                        <b-form-textarea v-model="v$.acknowledgeForm.comment.$model"
                                         :class="{ 'is-invalid': v$.acknowledgeForm.$error }"
                                         id="textarea-acknowlegde"
                                         name="textarea-acknowlegde"
                                         rows="3"
                                         max-rows="6"
                                         placeholder="comment"
                        ></b-form-textarea>
                        <div class="invalid-feedback" v-if="v$.acknowledgeForm.comment.required">{{ $t('Field is required') }}
                        </div>
                    </b-form-group>
                    <b-form-group id="input-group-ack-check"
                        :description="$t('forms.sticky-description', {obj: 'Service'})">
                        <b-form-checkbox
                            v-model="acknowledgeForm.sticky"
                            id="acknowlegde-sticky"
                            value=2
                            unchecked-value=0>
                            {{ $t('forms.sticky') }}
                        </b-form-checkbox>
                    </b-form-group>
                    <b-form-group id="input-group-ack-check2"
                                  :description="$t('forms.notify-description', {obj: 'Service'})">
                        <b-form-checkbox
                            v-model="acknowledgeForm.notify"
                            id="acknowlegde-notify"
                            value=1
                            unchecked-value=0>
                            {{ $t('forms.notify') }}
                        </b-form-checkbox>
                    </b-form-group>
                    <b-button variant="success" @click="submitAcknowledgement"
                              class="w-100">{{ $t('forms.send-command') }}
                    </b-button>
                </b-form>
            </b-list-group-item>
        </b-collapse>

        <b-button v-b-toggle.collapse-ack class="w-100 mb-1"
                  variant="outline-danger"
                  v-show="servicestatus.problemHasBeenAcknowledged && this.$store.state.canDeleteAcknowledgements"
                 @click="visibleDel = !visibleDel">
            <i class="fa-solid fa-trash"></i>
            {{ $t('action-items.remove-acknowledge')}}
        </b-button>
        <b-collapse v-model="visibleDel" class="mt-2 mb-2 w-100">
            <b-list-group-item>
                {{ $t('action-items.acknowledge-delete-confirm') }}
                <b-button variant="danger" @click="deleteAck" class="w-100">
                    {{ $t('forms.send-command') }}
                </b-button>
            </b-list-group-item>
        </b-collapse>
    </div>
</template>

<script>
import { required } from '@vuelidate/validators'
import { useVuelidate } from '@vuelidate/core'

export default {
    name: "Acknowledge",
    props: [
        'uuids',
        'ids',
        'servicestatus',
        'acknowledgement'
    ],
    data(){
        return {
            visible: false,
            visibleDel: false,
            acknowledgeForm: {
                comment: '',
                sticky: '0',
                notify: '1'
            },
        }
    },
    setup: () => ({ v$: useVuelidate() }),
    validations: {
        acknowledgeForm: {
            comment: {
                required,
            }
        }
    },
    methods: {
        async submitAcknowledgement(){
            this.v$.acknowledgeForm.$touch();
            const validated = await this.v$.acknowledgeForm.$validate();
            if(!validated){
                return;
            }

            let externalCommands = [];
            externalCommands.push({
                command: 'submitServicestateAck',
                hostUuid: this.uuids.hostuuid,
                serviceUuid: this.uuids.serviceuuid,
                sticky: parseInt(this.acknowledgeForm.sticky, 10),
                notify: parseInt(this.acknowledgeForm.notify, 10),
                author: this.$store.state.user,
                comment: this.acknowledgeForm.comment,
            })
            this.$emit('command', externalCommands, 'submit');
            this.visible = false;
        },
        deleteAck(){
            let externalCommand = {};
            externalCommand.hostId = this.ids.hostId;
            externalCommand.serviceId = this.ids.serviceId
            this.$emit('command', externalCommand, 'deleteAck');
            this.visibleDel = false;
        },
    }
}
</script>

<style scoped>

</style>
